// AppHandoffService — client for the "Add conversation" app-handoff contract
// (POST /api/app-handoff/create, GET /api/app-handoff/<code>).

import AuthService from './AuthService';

export interface HandoffCode {
  code: string;
  url: string;
  expiresAt: number;
}

export interface HandoffLookup {
  status: 'valid' | 'expired' | 'used' | 'not_found';
  businessName?: string;
  agentTitle?: string;
  kind?: 'session' | 'report';
}

export async function createHandoffCode(formId: string): Promise<HandoffCode> {
  const idToken = await AuthService.getInstance().getIdToken();
  if (!idToken) throw new Error('Could not sign in.');
  const response = await fetch('/api/app-handoff/create', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${idToken}` },
    body: JSON.stringify({ formId }),
  });
  if (!response.ok) throw new Error(`Failed to get a code (${response.status}).`);
  const data = await response.json();
  if (!data?.code) throw new Error('No code returned.');
  return data as HandoffCode;
}

export async function lookupHandoffCode(code: string): Promise<HandoffLookup> {
  const response = await fetch(`/api/app-handoff/${encodeURIComponent(code)}`);
  if (response.status === 404) return { status: 'not_found' };
  if (!response.ok) throw new Error(`Failed to look up code (${response.status}).`);
  return response.json();
}
